import HTTP from "../../../services/HTTP.js";

// fetch meetings
export const getMeetings = async (paramsOptions) => {
  const { page, limit } = paramsOptions || {};
  const res = await HTTP.get("/meetings", {
    params: {
      page,
      limit,
    },
  });
  return res.data;
};

// add meeting
export const addMeeting = async (data) => {
  const res = await HTTP.post("meetings/add", data);
  return res.data;
};

// update password
export const updateMeeting = async (data) => {
  const res = await HTTP.put("meetings/update", data);
  return res.data;
};
// delete password
export const deleteMeeting = async (id) => {
  const res = await HTTP.delete(`meetings/delete/${id}`);
  return res.data;
};
